import React, { useState } from 'react';
import { TokenInput } from '@components/TokenInput';
import { EthereumIcon } from '@components/icons/Ethereum';
import { OptimismIcon } from '@components/icons/Optimism';
import { Button } from '@components/main-components/button/Button';
import { StandardModal } from '@components/main-components/modals/StandardModal';
import { useBridge } from '@components/modals/Bridge/useBridge';
import { ModalContext } from '@context/modal';
import { AVAILABLE_CHAIN_IDS } from '@utils/constants';

export const BridgeModal = () => {
  const { closeCancelModal, closeModal } = ModalContext.useContainer();
  const [amount, setAmount] = useState<string | null>('');

  const {
    bridge,
    ethBalanceInEth,
    ethOptimismBalanceInEth,
    usdEthBalance,
    usdEthOptimismBalance,
    disabled,
    state,
    isLoading,
  } = useBridge({
    amountInEth: amount ?? '0',
    onBridge: closeModal,
  });

  const getBalanceString = (balance?: string, usdBalance?: string) => {
    if (!balance) return undefined;
    return `Balance: ${balance} ETH ${!!usdBalance ? `($${usdBalance} USD)` : ''}`;
  };

  const body = (
    <div className="grid gap-6">
      <span>Bridge your ETH to collect drops on Optimism.</span>
      <div className="grid gap-4">
        <div className="grid gap-1">
          <div className="text-base-l font-semibold text-black">From</div>
          {!!ethBalanceInEth && (
            <TokenInput
              chainId={AVAILABLE_CHAIN_IDS.eth}
              amount={amount}
              setAmount={setAmount}
              icon={<EthereumIcon />}
              tokenSymbol="ETH"
              balance={getBalanceString(ethBalanceInEth, usdEthBalance)}
              disabled={isLoading}
            />
          )}
        </div>
        <div className="grid gap-1">
          <div className="text-base-l font-semibold">To</div>
          {!!ethOptimismBalanceInEth && (
            <TokenInput
              chainId={AVAILABLE_CHAIN_IDS.optimism}
              amount={amount}
              setAmount={setAmount}
              icon={<OptimismIcon />}
              tokenSymbol="ETH"
              balance={getBalanceString(ethOptimismBalanceInEth, usdEthOptimismBalance)}
              disabled={isLoading}
            />
          )}
        </div>
      </div>
      <Button
        label={state}
        variant="primary"
        onClick={bridge}
        className="w-full flex-1"
        fullWidth
        disabled={disabled}
        loading={isLoading}
      />
    </div>
  );

  return (
    <StandardModal
      title="Bridge ETH"
      closeModal={closeCancelModal}
      body={body}
      bodyClassName="pt-4 pb-1"
    />
  );
};
